"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var d3 = _interopRequireWildcard(require("d3"));

var _d3Textwrap = require("d3-textwrap");

var _react = _interopRequireWildcard(require("react"));

var _types = require("./types");

var _propTypes = _interopRequireDefault(require("prop-types"));

var SankeyShapes = _interopRequireWildcard(require("./SankeyShapes"));

var _SankeyUtils = require("./SankeyUtils");

var _SankeyLayout = require("./SankeyLayout");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

window.d3 = d3;
var SankeyDrawPropTypes = {
  data: _propTypes.default.shape(_types.SankeyDataPropTypes).isRequired,
  set_data: _propTypes.default.func.isRequired,
  select_node: _propTypes.default.func.isRequired,
  nodeContextMenu: _propTypes.default.func.isRequired,
  node_color: _propTypes.default.func.isRequired,
  node_arrow_visible: _propTypes.default.func.isRequired,
  select_link: _propTypes.default.func.isRequired,
  linkContextMenu: _propTypes.default.func.isRequired,
  link_color: _propTypes.default.func.isRequired,
  link_text: _propTypes.default.func.isRequired,
  link_visible: _propTypes.default.func.isRequired,
  test_link_value: _propTypes.default.func.isRequired,
  set_show_nav: _propTypes.default.func.isRequired,
  set_nav_item_active: _propTypes.default.func.isRequired,
  nodeTooltipsContent: _propTypes.default.func.isRequired,
  linkTooltipsContent: _propTypes.default.func.isRequired,
  getValueIndex: _propTypes.default.func.isRequired
};

var SankeyDraw = function SankeyDraw(_ref) {
  var data = _ref.data,
      set_data = _ref.set_data,
      select_node = _ref.select_node,
      nodeContextMenu = _ref.nodeContextMenu,
      node_color = _ref.node_color,
      node_arrow_visible = _ref.node_arrow_visible,
      select_link = _ref.select_link,
      linkContextMenu = _ref.linkContextMenu,
      link_color = _ref.link_color,
      link_text = _ref.link_text,
      link_visible = _ref.link_visible,
      test_link_value = _ref.test_link_value,
      set_show_nav = _ref.set_show_nav,
      set_nav_item_active = _ref.set_nav_item_active,
      nodeTooltipsContent = _ref.nodeTooltipsContent,
      linkTooltipsContent = _ref.linkTooltipsContent,
      getValueIndex = _ref.getValueIndex;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      show_agregation = _useState2[0],
      set_show_agregation = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      agregation_parent_names = _useState4[0],
      set_agregation_parent_names = _useState4[1];

  var _useState5 = (0, _react.useState)([]),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      agregation_dimension_names = _useState6[0],
      set_agregation_dimension_names = _useState6[1];

  var _useState7 = (0, _react.useState)(true),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      is_agregation = _useState8[0],
      set_is_agregation = _useState8[1];

  var default_node_size = data.node_width;
  var default_handle_size = 10;
  var default_horiz_shift = 50;
  var min_thickness = 1;
  var display_nodes = data.nodes;
  var display_links = data.links;
  var handles_visible = (0, _toConsumableArray2.default)(new Array(Object.keys(display_links).length).fill(false));
  var sankeyTooltip = d3.select('body').append('div').style('opacity', 0).attr('class', 'tooltip').style('background-color', 'white').style('border', 'solid').style('border-width', '3px').style('border-radius', '5px').style('padding', '5px').style('max-width', '50%').style('font-size', '12px').style('z-index', 100).style('position', 'absolute').style('pointer-events', 'none');
  var alt_key_pressed = false;
  var value_index = getValueIndex(data);
  (0, _SankeyUtils.setSelectedTags)(data);

  var add_links = function add_links(static_sankey) {
    var remove_previous_links = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    // Structure svg du link
    //- link : 
    //- text : 
    //- rect :
    //- rect :
    //- arrow :       
    var display_style = data.display_style;

    if (remove_previous_links) {
      d3.select('#g_links').selectAll('.gg_links').remove();
    }

    d3.select('#svg').selectAll('.link_value').remove();

    if (display_links === undefined) {
      return;
    }

    var gg_links = d3.select('#g_links').selectAll('.gg_links').data(Object.values(display_links)).enter().append('g').attr('id', function (d) {
      return 'gg_' + d.idLink;
    }).attr('class', 'gg_links') // On gere la visibilité directement sur gg_nodes avec un display <inline />
    .style('display', function (d) {
      var display;

      if (link_visible(d)) {
        display = 'inline';
      } else {
        display = 'none';
      }

      return display;
    });
    var paths = gg_links.append('path');

    if (!static_sankey) {
      var _error_msg;

      paths.call(d3.drag().subject(Object).on('drag', function (event) {
        drag_link(display_nodes, display_links, display_style, data.tags_catalog, this, event);
        Object.values(display_links).forEach(function (link) {
          d3.select('#' + link.idLink).attr('d', function () {
            return drawCurve(display_nodes, display_links, display_style, data.tags_catalog, link, _error_msg);
          });
        });
      }));
      paths.on('contextmenu', function (event, l) {
        event.preventDefault();
        sankeyTooltip.style('opacity', 0);
        sankeyTooltip.style('opacity', 0);
        linkContextMenu(l);
      });
    } // link value
    // const select = gg_links
    //   .filter(d => d.label_position !== 'frozen' && d.label_on_path === true)
    //   .append('text')
    //   .append('textPath')


    gg_links.filter(function (d) {
      return d.label_position !== 'frozen' && d.label_on_path === true;
    }).append('text').attr('pointer-events', 'none').attr('style', 'font-weight: bold;font-family:Arial; font-size:' + display_style.font_size + 'px;').attr('fill', function (l) {
      if (l.text_color === l.color && l.orthogonal_label_position === 'middle') {
        return 'white';
      }

      return l.text_color;
    }) //.attr('visibility', d => link_visible(d))
    .attr('dy', function (l) {
      if (l.orthogonal_label_position === 'middle') {
        return '0.3em';
      } else if (l.orthogonal_label_position === 'below') {
        return scale(l.value[value_index]) / 2 + 10 + 'px';
      } else if (l.orthogonal_label_position === 'above') {
        return -scale(l.value[value_index]) / 2 + 'px';
      }

      return '0.3em';
    }).append('textPath').attr('id', function (d) {
      return d.idLink + '_text';
    }).attr('class', 'link_value').attr('href', function (d) {
      return '#' + d.idLink;
    });
    var select2 = gg_links.filter(function (d) {
      return d.label_position === 'frozen' || !d.label_on_path || d.label_on_path === undefined;
    }).append('text'); // select
    //   .attr('href', d => '#link' + links.indexOf(d))
    //   .attr('id', d => 'link_value' + links.indexOf(d))
    //   .attr('class', 'link_value')
    //   .attr('style', 'font-weight: bold;font-family:Arial; font-size:' + display_style.font_size + 'px;')
    //   .attr('fill', d => d.text_color)
    //   .attr('visibility', d => link_visible(d))

    select2.attr('href', function (d) {
      return '#' + d.idLink;
    }).attr('id', function (d) {
      return d.idLink + '_text';
    }).attr('class', 'link_value').attr('style', 'font-weight: bold;font-family:Arial; font-size:' + display_style.font_size + 'px;').attr('fill', function (l) {
      if (l.text_color === l.color && l.orthogonal_label_position === 'middle') {
        return 'white';
      }

      return l.text_color;
    }).attr('visibility', function (d) {
      return link_visible(d) && d.value[value_index] >= Math.max(data.display_style.filter, data.display_style.filter_label) ? 'visible' : 'hidden';
    });

    if (!static_sankey) {
      // A voir avec Julien
      select2.call(d3.drag().subject(Object).on('drag', function (event, link) {
        if (alt_key_pressed) {
          drag_link_text(link, event);
        }
      })).on('click', function (event, d) {
        var source_node = display_nodes[d.idSource];
        var target_node = display_nodes[d.idTarget];
        select_link(d); // if classic link

        if (d.orientation === 'hh' && source_node.x < target_node.x) {
          d3.select('#link_center' + d.idLink).attr('fill-opacity', 0.7);
        }
      });
    }

    if (!static_sankey) {
      select2.call(d3.drag().subject(Object).on('drag', function (event, link) {
        if (alt_key_pressed) {
          drag_link_text(link, event);
        } else {
          var text_id = d3.select(this).attr('id');
          var link_to_drag = text_id.substring(text_id.length - 5);
          drag_link(display_nodes, display_links, display_style, data.tags_catalog, d3.select(link_to_drag).node(), event);
        }
      }));
    }

    var error_msg;
    paths.attr('class', 'link').attr('id', function (d) {
      return d.idLink;
    }).attr('fill', 'none').attr('stroke-opacity', function (d) {
      return data.nodes[d.idSource].node_visible && data.nodes[d.idTarget].node_visible && d.value[value_index] >= display_style.filter ? !data.show_uncert && String(d.display_value[value_index]).includes('[') ? 0.85 : 0.85 : 0;
    }).attr('stroke-width', function (d) {
      var link_value = test_link_value(display_nodes, d, data.tags_catalog);
      return scale(Math.max(inv_scale(min_thickness), link_value ? link_value : 0));
    }) //.attr('stroke',d => d.unbounded ? 'darkred' : d.color)
    .attr('stroke', function (l) {
      return link_color(l, value_index);
    }).on('mouseover', function (event, d) {
      if (!static_sankey && !event.shiftKey) {
        return;
      }

      sankeyTooltip.style('opacity', 1).html(linkTooltipsContent(data, d, getValueIndex));

      if (data.nodes[d.idSource].node_visible && data.nodes[d.idTarget].node_visible && d.value[value_index] >= display_style.filter) {
        return d3.select(this).attr('stroke-opacity', '0.5');
      }
    }).on('mousemove', function (event) {
      if (!static_sankey && !event.shiftKey) {
        return;
      }

      sankeyTooltip.style('top', event.layerY - 10 + 'px').style('left', event.layerX + 10 + 'px');
    }).on('mouseout', function (event, d) {
      sankeyTooltip.style('opacity', 0);

      if (data.nodes[d.idSource].node_visible && data.nodes[d.idTarget].node_visible && d.value[value_index] >= display_style.filter) {
        var opacity = String(d.display_value[value_index]).includes('[') ? 0.85 : 0.85;
        return d3.select(this).attr('stroke-opacity', opacity);
      }
    });
    var firing = false;

    var singleClick = function singleClick(link) {
      select_link(link);
    };

    var doubleClick = function doubleClick(link) {
      var id = Object.values(display_links).indexOf(link);
      handles_visible[id] = !handles_visible[id];
      var shift_handles;

      if (Object.values(display_links)[id].recycling) {
        shift_handles = ['#vert_shift', '#left_horiz_shift', '#right_horiz_shift'];
      } else {
        shift_handles = ['#left_horiz_shift', '#right_horiz_shift'];
      }

      for (var i = 0; i < shift_handles.length; i++) {
        var str = shift_handles[i] + link.idLink;
        var sel = d3.select(str);

        if (handles_visible[id]) {
          sel.attr('fill-opacity', '0.7');
        } else {
          sel.attr('fill-opacity', '0');
        }
      }
    };

    var firingFunc = singleClick;
    paths.on('dblclick', function () {
      firingFunc = doubleClick;
    });
    paths.on('click', function (event, d) {
      if (event.ctrlKey) {
        // set_selected_node(nodes.filter(f => { return f.name == event.target.value })[0].id)
        sankeyTooltip.style('opacity', 0);
        select_link(d);
        set_nav_item_active('3'); //set_show_nav(false)

        set_show_nav(true);
      } else {
        sankeyTooltip.style('opacity', 0);

        if (firing) {
          return;
        }

        firing = true; //const i = display_links.indexOf(d)

        setTimeout(function () {
          firingFunc(d);
          firingFunc = singleClick;
          firing = false;
        }, 300);
      }
    });
    paths.attr('d', function (d) {
      setNodesHeight(display_nodes, display_links, d, data.tags_catalog);
      return drawCurve(display_nodes, display_links, display_style, data.tags_catalog, d, error_msg);
    });

    if (error_msg && error_msg.text) {
      alert(error_msg.text);
    } //Creation des Arrows associés au link


    d3.selectAll('.ggg_nodes').filter(function (n) {
      return node_arrow_visible(n);
    }).each(function (n) {
      var selection = d3.select(this);
      drawArrows(n, display_nodes, display_links, display_style, data.tags_catalog, selection);
    }); // if (document.getElementById('front-0')){
    //   document.getElementById('svg').appendChild(document.getElementById('front-0'))
    // }
    // move_links_values_forward(links.length)
  };

  var update_scale = function update_scale(user_scale) {
    scale.domain([0, user_scale]);
    inv_scale.range([0, user_scale]); //link_default_width = user_scale/20
  };

  var deselect_nodes_and_links = function deselect_nodes_and_links() {
    d3.select('#g_nodes').selectAll('.selected_node').attr('class', 'node');
    d3.select('#g_links').selectAll('path').attr('class', 'link');
  };

  var drag_node = function drag_node(nodes, links, display_style, tags_catalog, dragged, event) {
    var width = data.width; //- ggg_node5 -> node5

    var idNode = dragged.id.substring(4);
    var node = nodes[idNode];
    var old_x = +node.x;
    var old_y = +node.y;
    var new_x = old_x + event.dx;
    var new_y = old_y + event.dy;

    if (new_x < 0 || new_x > width - default_node_size || new_y < 0 || new_y > height - default_node_size) {
      return;
    }

    node.x = new_x;
    node.y = new_y;
    sankeyTooltip.style('opacity', 0); // Fermeture de la tooltip au click

    d3.select(dragged).attr('transform', 'translate(' + new_x + ',' + new_y + ')');
    d3.select('#tooltip_node' + idNode).attr('transform', 'translate(' + (new_x + 50) + ',' + (new_y + 20) + ')');
    var error_msg = {};
    Object.values(links).forEach(function (link) {
      if (link.idSource === node.idNode || link.idTarget === node.idNode) {
        // Redraw link
        var old_x_pos = +d3.select('#' + link.idLink + '_text').attr('x');
        var old_y_pos = +d3.select('#' + link.idLink + '_text').attr('y');

        if (!(link.label_position === 'frozen')) {
          d3.select('#' + link.idLink + '_text').attr('x', old_x_pos + 1 / 2 * (new_x - old_x));
          d3.select('#' + link.idLink + '_text').attr('y', old_y_pos + 1 / 2 * (new_y - old_y));
        } // select allows to redraw directly without refreshing


        d3.select('#' + link.idLink).attr('d', function () {
          return drawCurve(nodes, links, display_style, data.tags_catalog, link, error_msg);
        });
        var target_node = nodes[link.idTarget];

        if (link.arrow) {
          var node_select = d3.select('#ggg_' + target_node.idNode);
          drawArrows(target_node, nodes, links, display_style, tags_catalog, node_select);
        }

        for (var i = 0; i < target_node.inputLinksId.length; i++) {
          d3.select('#' + target_node.inputLinksId[i]).attr('d', function (link) {
            return drawCurve(nodes, links, display_style, tags_catalog, link, error_msg);
          });
        }

        for (var _i = 0; _i < target_node.outputLinksId.length; _i++) {
          d3.select('#' + target_node.outputLinksId[_i]).attr('d', function (link) {
            return drawCurve(nodes, links, display_style, tags_catalog, link, error_msg);
          });
        }
      }
    });

    if (error_msg.text !== undefined) {
      alert(error_msg);
    }
  };

  var drag_link = function drag_link(nodes, links, display_style, tags_catalog, dragged, event) {
    var idLink = d3.select(dragged).attr('id');
    var p2 = d3.pointer(event, d3.select('#g_links').node());
    var linked_node = identify_node(nodes, links, links[idLink], p2);

    if (linked_node === undefined) {
      return;
    }

    var node = nodes[linked_node.node_id];

    if (linked_node.type === 'source') {
      var source_order = node.outputLinksId.indexOf(idLink);
      var output_offset = 0;

      for (var i = 1; i < node.outputLinksId.length; i++) {
        var link = links[node.outputLinksId[i - 1]];

        if (i > source_order) {
          break;
        }

        output_offset += link.value[value_index];
      }

      var number_of_links = node.outputLinksId.length;
      var value = links[idLink].value;

      if (links[idLink].orientation === 'hh') {
        if (source_order < number_of_links - 1 && d3.pointer(event, d3.select('#g_links').node())[1] + event.dy >= linked_node.origin + scale(output_offset + value[value_index])) {
          swap(node.outputLinksId, source_order, source_order + 1);
        }

        if (source_order > 0 && d3.pointer(event, d3.select('#g_links').node())[1] + event.dy <= linked_node.origin + scale(output_offset)) {
          swap(node.outputLinksId, source_order, source_order - 1);
        }
      } else if (links[idLink].orientation === 'vv') {
        if (source_order < number_of_links - 1 && d3.pointer(event, d3.select('#g_links').node())[0] + event.dx >= linked_node.origin + scale(output_offset + value[value_index])) {
          swap(node.outputLinksId, source_order, source_order + 1);
        }

        if (source_order > 0 && d3.pointer(event, d3.select('#g_links').node())[0] + event.dx <= linked_node.origin + scale(output_offset)) {
          swap(node.outputLinksId, source_order, source_order - 1);
        }
      }
    }

    if (linked_node.type === 'target') {
      var target_order = node.inputLinksId.indexOf(idLink);
      var input_offset = 0;

      for (var _i2 = 1; _i2 < node.inputLinksId.length; _i2++) {
        if (_i2 > target_order) {
          break;
        }

        input_offset += links[node.inputLinksId[_i2 - 1]].value[value_index];
      }

      var _number_of_links = node.inputLinksId.length;
      var _value = links[idLink].value;

      if (links[idLink].orientation === 'hh') {
        if (target_order < _number_of_links - 1 && d3.pointer(event, d3.select('#g_links').node())[1] + event.dy >= linked_node.origin + scale(input_offset + _value[value_index])) {
          swap(node.inputLinksId, target_order, target_order + 1);
        }

        if (target_order > 0 && d3.pointer(event, d3.select('#g_links').node())[1] + event.dy <= linked_node.origin + scale(input_offset)) {
          swap(node.inputLinksId, target_order, target_order - 1);
        }
      } else if (links[idLink].orientation === 'vv') {
        if (target_order < _number_of_links - 1 && d3.pointer(event, d3.select('#g_links').node())[0] + event.dx >= linked_node.origin + scale(input_offset + _value[value_index])) {
          swap(node.inputLinksId, target_order, target_order + 1);
        }

        if (target_order > 0 && d3.pointer(event, d3.select('#g_links').node())[0] + event.dx <= linked_node.origin + scale(input_offset)) {
          swap(node.inputLinksId, target_order, target_order - 1);
        }
      }

      var node_select = d3.select('#ggg_' + node.idNode);
      drawArrows(node, nodes, links, display_style, tags_catalog, node_select);
    }
  };

  var drag_handle = function drag_handle(link, nodes, links, display_style, selected_tags, dragged, handle_type, the_event) {
    var width = data.width;
    var old_x = +d3.select(dragged).attr('transform').split(',')[0].substring(10);
    var old_y_str = d3.select(dragged).attr('transform').split(',')[1];
    var old_y = +old_y_str.substring(0, old_y_str.length - 1);
    var new_x = old_x + the_event.dx;
    var new_y = old_y + the_event.dy;
    var d = d3.select(dragged).data()[0];
    var u_center_new = -1;
    var source_node = nodes[d.idSource];
    var target_node = nodes[d.idTarget];

    var _compute_end_points = compute_end_points(source_node, target_node, link, nodes, links, selected_tags),
        _compute_end_points2 = (0, _slicedToArray2.default)(_compute_end_points, 4),
        xs = _compute_end_points2[0],
        ys = _compute_end_points2[1],
        xt = _compute_end_points2[2],
        yt = _compute_end_points2[3];

    if (!d.recycling) {
      if (d.orientation === 'hh') {
        var link_x_length = Math.abs(xt - xs);
        u_center_new = Math.abs(new_x - xs) / link_x_length;
      } else if (d.orientation === 'vv') {
        var link_y_length = Math.abs(yt - ys);
        u_center_new = Math.abs(new_y - ys) / link_y_length;
      }

      if (u_center_new >= 0 && u_center_new <= 1) {
        if (handle_type === 'left') {
          d.left_horiz_shift = u_center_new;
        } else {
          d.right_horiz_shift = u_center_new;
        }
      } else {
        return;
      }
    } else if (handle_type === 'vert') {
      //if (d.vert_shift + event.dy > -0.5 * scale(d.value[value_index]) && new_y < height - scale(d.value[value_index])/2) {
      if (new_y < height - scale(d.value[value_index]) / 2) {
        d.vert_shift += the_event.dy;
      } else {
        return;
      }
    } else if (handle_type === 'left') {
      if (d.left_horiz_shift + the_event.dx < default_horiz_shift && new_x > scale(d.value[value_index]) / 2) {
        d.left_horiz_shift += the_event.dx;
      } else {
        return;
      }
    } else if (handle_type === 'right') {
      if (d.right_horiz_shift + the_event.dx > -default_horiz_shift && new_x < width - scale(d.value[value_index]) / 2) {
        d.right_horiz_shift += the_event.dx;
      } else {
        return;
      }
    } //links[link_id] = d // Update data then update viz


    d3.select('#' + d.idLink).attr('d', function () {
      var error_msg;
      return drawCurve(nodes, links, display_style, data.tags_catalog, d, error_msg);
    });
  }; // Identify the node that is the closest from mouse click (either source or target).


  var identify_node = function identify_node(nodes, links, link, mouse_coord) {
    var source_node = nodes[link.idSource];
    var target_node = nodes[link.idTarget];
    var source_x_min = source_node.x;
    var source_x_max = source_x_min + parseInt(d3.select('#' + source_node.idNode).attr('width'));
    var source_y_min = source_node.y;
    var source_y_max = source_y_min + parseInt(d3.select('#' + source_node.idNode).attr('height'));
    var target_x_min = target_node.x;
    var target_x_max = target_x_min + parseInt(d3.select('#' + target_node.idNode).attr('width'));
    var target_y_min = target_node.y;
    var target_y_max = target_y_min + parseInt(d3.select('#' + target_node.idNode).attr('height'));
    var tolerance = 3 * default_node_size;

    if ((link.orientation === 'hh' || link.orientation === 'hv') && mouse_coord[1] >= source_y_min && mouse_coord[1] <= source_y_max && mouse_coord[0] <= source_x_max + tolerance) {
      return {
        'node_id': source_node.idNode,
        'type': 'source',
        'origin': source_y_min
      };
    }

    if ((link.orientation === 'hh' || link.orientation === 'hv') && mouse_coord[1] >= target_y_min && mouse_coord[1] <= target_y_max && mouse_coord[0] >= target_x_min - tolerance) {
      return {
        'node_id': target_node.idNode,
        'type': 'target',
        'origin': target_y_min
      };
    }

    if ((link.orientation === 'vv' || link.orientation === 'vh') && mouse_coord[0] >= source_x_min && mouse_coord[0] <= source_x_max && mouse_coord[1] <= source_y_max + tolerance) {
      return {
        'node_id': source_node.idNode,
        'type': 'source',
        'origin': source_x_min
      };
    }

    if ((link.orientation === 'vv' || link.orientation === 'vh') && mouse_coord[0] >= target_x_min && mouse_coord[0] <= target_x_max && mouse_coord[1] >= target_y_min - tolerance) {
      return {
        'node_id': target_node.idNode,
        'type': 'target',
        'origin': target_x_min
      };
    }
  };

  var add_shift_handle = function add_shift_handle(link, nodes, links, display_style, selected_tags, shift_name, position) {
    d3.select('#gg_' + link.idLink).append('rect').attr('id', shift_name + link.idLink).attr('fill-opacity', '0').attr('width', default_handle_size).attr('height', default_handle_size).on('mouseover', function () {
      d3.select(this).attr('fill-opacity', '0.7');
    }).on('mouseout', function () {
      d3.select(this).attr('fill-opacity', '0');
    }).call(d3.drag().subject(Object).on('drag', function (event) {
      drag_handle(link, nodes, links, display_style, selected_tags, this, position, event);
    }));
  };

  var add_shift_handles = function add_shift_handles(link, nodes, links, display_style, selected_tags, xs, ys, xt, yt) {
    var shift_handles;

    if (link.recycling) {
      shift_handles = [['vert_shift', 'vert'], ['left_horiz_shift', 'left'], ['right_horiz_shift', 'right']];
    } else {
      shift_handles = [['left_horiz_shift', 'left'], ['right_horiz_shift', 'right']];
    }

    for (var i = 0; i < shift_handles.length; i++) {
      var selection = d3.select('#' + shift_handles[i][0] + link.idLink);

      if (selection.empty()) {
        // if the handle do not exist, create it
        add_shift_handle(link, nodes, links, display_style, selected_tags, shift_handles[i][0], shift_handles[i][1]);
      }
    }

    var _loop = function _loop(_i3) {
      // Draw handle at the correct position
      d3.select('#' + shift_handles[_i3][0] + link.idLink).attr('transform', function () {
        var handle_pos = handles_positions(links, link, xs, ys, xt, yt);
        return handle_pos[_i3]; // 0 => vertical handle
      });
    };

    for (var _i3 = 0; _i3 < shift_handles.length; _i3++) {
      _loop(_i3);
    }
  };

  var drawLinkText = function drawLinkText(link, links, link_value, display_style, xs, ys, xt, yt) {
    var x_pos = 0;
    var y_pos = 0;

    if (!link.label_position) {
      link.label_position = 'middle';
    }

    if (link.label_position === 'beginning') {
      x_pos = xs + (xt - xs) / 10;
    } else if (link.label_position === 'middle') {
      var handles = handles_positions(links, link, xs, ys, xt, yt);

      if (handles.length >= 2) {
        var left_xpos = +handles[0].split(',')[0].substring(10);
        var right_xpos = +handles[1].split(',')[0].substring(10);
        x_pos = (left_xpos + right_xpos) / 2 - 5;
      } else {
        x_pos = +handles[0].split(',')[0].substring(10);
      }
    } else if (link.label_position === 'end') {
      //end
      x_pos = xt - (xt - xs) / 10;
    }

    if (link.label_position === 'beginning') {
      y_pos = ys - 6;
    } else if (link.label_position === 'middle') {
      var _handles = handles_positions(links, link, xs, ys, xt, yt);

      if (_handles.length >= 2) {
        var left_y_pos_str = _handles[0].split(',')[1];

        var left_y_pos = +left_y_pos_str.substring(0, left_y_pos_str.length - 1);

        var right_y_pos_str = _handles[1].split(',')[1];

        var right_y_pos = +right_y_pos_str.substring(0, right_y_pos_str.length - 1);
        y_pos = (left_y_pos + right_y_pos) / 2;
      } else {
        var y_pos_str = _handles[0].split(',')[1];

        y_pos = +y_pos_str.substring(0, y_pos_str.length - 1);
      }
    } else if (link.label_position === 'end') {
      //end
      y_pos = yt - 6;
    }

    if (link.label_position !== 'frozen') {
      link.x_label = x_pos;
      link.y_label = y_pos;
    }

    if (link.label_position === 'frozen' && link.x_label || !link.label_on_path || link.label_on_path === undefined) {
      d3.select('#' + link.idLink + '_text').attr('x', function () {
        return link.label_position === 'frozen' && link.x_label ? link.x_label : x_pos;
      }).attr('y', function () {
        return link.label_position === 'frozen' && link.y_label ? link.y_label + default_handle_size : y_pos + default_handle_size;
      }).text(function (d) {
        return link_text(d, link_value, display_style, value_index);
      }).attr('visibility', link.label_visible ? 'visible' : 'hidden');
    } else {
      var positions = {
        'frozen': ['50%', 'start'],
        'beginning': ['10px', 'start'],
        'middle': ['50%', 'start'],
        'end': ['100%', 'end']
      };
      d3.select('#' + link.idLink + '_text').attr('startOffset', positions[link.label_position][0]).attr('text-anchor', positions[link.label_position][1]) //.text(d => ' → ' +link_text(d, link_value, display_style) + ' → ')
      .text(function (d) {
        return link_text(d, link_value, display_style, value_index);
      }).attr('visibility', link.label_visible ? 'visible' : 'hidden');
    }
  };

  var setNodeHeight = function setNodeHeight(n, nodes, links, selected_tags) {
    var res = (0, _SankeyUtils.compute_total_offsets)(n, nodes, links, selected_tags, test_link_value);

    var _res = (0, _slicedToArray2.default)(res, 4),
        total_offset_height_left = _res[0],
        total_offset_height_right = _res[1],
        total_offset_width_top = _res[2],
        total_offset_width_bottom = _res[3]; // Hauteur des noeuds


    var node_size_s_height = Math.max(inv_scale(3), total_offset_height_left, total_offset_height_right);
    var node_size_s_width = Math.max(inv_scale(default_node_size), total_offset_width_top, total_offset_width_bottom);
    d3.select('#' + n.idNode).attr('width', scale(node_size_s_width));
    d3.select('#' + n.idNode).attr('height', scale(node_size_s_height));

    if (n.type === 'product') {
      d3.select('#' + n.idNode).attr('rx', scale(node_size_s_width / 2));
      d3.select('#' + n.idNode).attr('cx', scale(node_size_s_width / 2));
      d3.select('#' + n.idNode).attr('ry', scale(node_size_s_height / 2));
      d3.select('#' + n.idNode).attr('cy', scale(node_size_s_height / 2));
    }
  };

  var setNodesHeight = function setNodesHeight(nodes, links, d, tags_catalog) {
    var source_node = nodes[d.idSource];
    var target_node = nodes[d.idTarget];

    if (target_node === undefined) {
      target_node = nodes[d.idTarget];
    }

    if (source_node === undefined) {
      var filter_idSource = d.idSource;
      source_node = nodes[filter_idSource];
    }

    var res = (0, _SankeyUtils.compute_total_offsets)(source_node, nodes, links, tags_catalog, test_link_value);

    var _res2 = res,
        _res3 = (0, _slicedToArray2.default)(_res2, 4),
        s_total_offset_height_left = _res3[0],
        s_total_offset_height_right = _res3[1],
        s_total_offset_width_top = _res3[2],
        s_total_offset_width_bottom = _res3[3];

    res = (0, _SankeyUtils.compute_total_offsets)(target_node, nodes, links, tags_catalog, test_link_value);

    var _res4 = res,
        _res5 = (0, _slicedToArray2.default)(_res4, 4),
        t_total_offset_height_left = _res5[0],
        t_total_offset_height_right = _res5[1],
        t_total_offset_width_top = _res5[2],
        t_total_offset_width_bottom = _res5[3]; // Hauteur des noeuds


    var node_size_s_height = Math.max(inv_scale(3), s_total_offset_height_left, s_total_offset_height_right);
    var node_size_t_height = Math.max(inv_scale(3), t_total_offset_height_left, t_total_offset_height_right);
    var node_size_s_width = Math.max(inv_scale(default_node_size), s_total_offset_width_top, s_total_offset_width_bottom);
    var node_size_t_width = Math.max(inv_scale(default_node_size), t_total_offset_width_top, t_total_offset_width_bottom);
    d3.select('#' + source_node.idNode).attr('width', scale(node_size_s_width));
    d3.select('#' + source_node.idNode).attr('height', scale(node_size_s_height));

    if (source_node.type === 'product') {
      d3.select('#' + source_node.idNode).attr('rx', scale(node_size_s_width / 2));
      d3.select('#' + source_node.idNode).attr('cx', scale(node_size_s_width / 2));
      d3.select('#' + source_node.idNode).attr('ry', scale(node_size_s_height / 2));
      d3.select('#' + source_node.idNode).attr('cy', scale(node_size_s_height / 2));
    }

    d3.select('#' + target_node.idNode).attr('width', scale(node_size_t_width));
    d3.select('#' + target_node.idNode).attr('height', scale(node_size_t_height));

    if (target_node.type === 'product') {
      d3.select('#' + target_node.idNode).attr('rx', scale(node_size_t_width / 2));
      d3.select('#' + target_node.idNode).attr('cx', scale(node_size_t_width / 2));
      d3.select('#' + target_node.idNode).attr('ry', scale(node_size_t_height / 2));
      d3.select('#' + target_node.idNode).attr('cy', scale(node_size_t_height / 2));
    }
  };

  var compute_end_points = function compute_end_points(source_node, target_node, link, nodes, links, selected_tags) {
    if (!links) {
      return [0, 0, 0, 0];
    }

    var link_value = test_link_value(nodes, link, selected_tags);

    if (link_value === undefined) {
      return [0, 0, 0, 0];
    }

    var res = (0, _SankeyUtils.compute_total_offsets)(source_node, nodes, links, selected_tags, test_link_value);

    var _res6 = res,
        _res7 = (0, _slicedToArray2.default)(_res6, 4),
        s_total_offset_height_left = _res7[0],
        s_total_offset_height_right = _res7[1],
        s_total_offset_width_top = _res7[2],
        s_total_offset_width_bottom = _res7[3];

    res = (0, _SankeyUtils.compute_total_offsets)(target_node, nodes, links, selected_tags, test_link_value);

    var _res8 = res,
        _res9 = (0, _slicedToArray2.default)(_res8, 4),
        t_total_offset_height_left = _res9[0],
        t_total_offset_height_right = _res9[1],
        t_total_offset_width_top = _res9[2],
        t_total_offset_width_bottom = _res9[3];

    var node_size_s_width = Math.max(inv_scale(default_node_size), s_total_offset_width_bottom, s_total_offset_width_top);
    var node_size_t_width = Math.max(inv_scale(default_node_size), t_total_offset_width_bottom, t_total_offset_width_top);
    var node_size_s_height = Math.max(inv_scale(3), s_total_offset_height_left, s_total_offset_height_right);
    var node_size_t_height = Math.max(inv_scale(3), t_total_offset_height_left, t_total_offset_height_right);
    res = (0, _SankeyUtils.compute_total_offsets)(source_node, nodes, links, selected_tags, test_link_value, link);

    var _res10 = res,
        _res11 = (0, _slicedToArray2.default)(_res10, 4),
        s_offset_height_left = _res11[0],
        s_offset_height_right = _res11[1],
        s_offset_width_top = _res11[2],
        s_offset_width_bottom = _res11[3];

    res = (0, _SankeyUtils.compute_total_offsets)(target_node, nodes, links, selected_tags, test_link_value, link);

    var _res12 = res,
        _res13 = (0, _slicedToArray2.default)(_res12, 4),
        t_offset_height_left = _res13[0],
        t_offset_height_right = _res13[1],
        t_offset_width_top = _res13[2],
        t_offset_width_bottom = _res13[3];

    var delta_s_width_bottom = Math.max(0, (node_size_s_width - s_total_offset_width_bottom) / 2);
    var delta_s_width_top = Math.max(0, (node_size_s_width - s_total_offset_width_top) / 2);
    var delta_s_height_right = Math.max(0, (node_size_s_height - s_total_offset_height_right) / 2);
    var delta_s_height_left = Math.max(0, (node_size_s_height - s_total_offset_height_left) / 2);
    var delta_t_width_bottom = Math.max(0, (node_size_t_width - t_total_offset_width_bottom) / 2);
    var delta_t_width_top = Math.max(0, (node_size_t_width - t_total_offset_width_top) / 2);
    var delta_t_height_right = Math.max(0, (node_size_t_height - t_total_offset_height_right) / 2);
    var delta_t_height_left = Math.max(0, (node_size_t_height - t_total_offset_height_left) / 2);
    var xs = +source_node.x;
    var ys = +source_node.y;
    var xt = +target_node.x;
    var yt = +target_node.y;

    if (link.orientation === 'hh') {
      //side to side
      if (source_node.x > target_node.x && !link.recycling || source_node.x < target_node.x && link.recycling) {
        // source is after target arrow point leftward. Start is on the left of side of source
        // source -> left
        //xs = xs
        ys += scale(delta_s_height_left + s_offset_height_left + link_value / 2); // target -> right

        xt += scale(node_size_t_width);
        yt += scale(delta_t_height_right + t_offset_height_right + link_value / 2);

        if (link.arrow) {
          xt = xt + 10;
        }
      } else {
        // source is before target arrow point rightward. Start is on the right of side of source
        var _delta_s_height_right = Math.max(0, (node_size_s_height - s_total_offset_height_right) / 2);

        xs += scale(node_size_s_width);
        ys += scale(_delta_s_height_right + s_offset_height_right + link_value / 2); //xt = xt

        yt += scale(delta_t_height_left + t_offset_height_left + link_value / 2);

        if (link.arrow) {
          xt = xt - 10;
        }
      }
    }

    if (link.orientation === 'vv') {
      //side to side
      if (source_node.y > target_node.y) {
        // source is bottom target. Flux goes up
        xs += scale(delta_s_width_top + s_offset_width_top + link_value / 2); //ys = ys

        xt += scale(delta_t_width_bottom + t_offset_width_bottom + link_value / 2);
        yt += scale(node_size_t_height);

        if (link.arrow) {
          yt = yt + 10;
        }
      } else {
        // source is top target. Flux goes down
        xs += scale(delta_s_width_bottom + s_offset_width_bottom + link_value / 2);
        ys += scale(node_size_s_height);
        xt += scale(delta_t_width_top + t_offset_width_top + link_value / 2); //yt += scale(node_size_t_height)

        if (link.arrow) {
          yt = yt - 10;
        }
      }
    }

    if (link.orientation === 'hv') {
      //vertical to horizontal
      if (source_node.x > target_node.x) {
        if (source_node.y > target_node.y) {
          //source is bottom right target. left and up  
          //xs = xs
          ys += scale(delta_s_height_left + s_offset_height_left + link_value / 2);
          xt += scale(delta_t_width_bottom + t_offset_width_bottom + link_value / 2);
          yt += scale(node_size_t_height);

          if (link.arrow) {
            yt = yt + 10;
          }
        } else {
          //source is top right target. left and down
          //xs = xs
          ys += scale(delta_s_height_left + s_offset_height_left + link_value / 2);
          xt += scale(delta_t_width_top + t_offset_width_top + link_value / 2); //yt = yt

          if (link.arrow) {
            yt = yt - 10;
          }
        }
      } else {
        if (source_node.y > target_node.y) {
          //source is bottom left target. right and up
          xs += scale(node_size_s_width);
          ys += scale(delta_s_height_right + s_offset_height_right + link_value / 2);
          xt += scale(delta_t_width_bottom + t_offset_width_bottom + link_value / 2);
          yt += scale(node_size_t_height);

          if (link.arrow) {
            yt = yt + 10;
          }
        } else {
          //source is top left target. right and down
          xs += scale(node_size_s_width);
          ys += scale(delta_s_height_right + s_offset_height_right + link_value / 2);
          xt += scale(delta_t_width_top + t_offset_width_top + link_value / 2); //yt = yt

          if (link.arrow) {
            yt = yt - 10;
          }
        }
      }
    }

    if (link.orientation === 'vh') {
      //vertical to horizontal
      if (source_node.x > target_node.x) {
        if (source_node.y > target_node.y) {
          //source is bottom right target. up and left
          xs += scale(delta_s_width_top + s_offset_width_top + link_value / 2); //ys = ys

          xt += scale(node_size_t_width);
          yt += scale(delta_t_height_right + t_offset_height_right + link_value / 2);

          if (link.arrow) {
            xt += 10;
          }
        } else {
          //source is top right target. down and left
          xs += scale(delta_s_width_bottom + s_offset_width_bottom + link_value / 2);
          ys += scale(node_size_s_height);
          xt += scale(node_size_t_width);
          yt += scale(delta_t_height_right + t_offset_height_right + link_value / 2);

          if (link.arrow) {
            xt += 10;
          }
        }
      } else {
        if (source_node.y > target_node.y) {
          //source is bottom left target. Arrow goes left and go down to the top side 
          xs += scale(delta_s_width_top + s_offset_width_top + link_value / 2); //ys = ys
          //xt = xt

          yt += scale(delta_t_height_left + t_offset_height_left + link_value / 2);

          if (link.arrow) {
            xt = xt - 10;
          }
        } else {
          //source is top left target. Arrow goes left and go down to the top side 
          xs += scale(delta_s_width_bottom + s_offset_width_bottom + link_value / 2);
          ys += scale(node_size_s_height); //xt = xt

          yt += scale(delta_t_height_left + t_offset_height_left + link_value / 2);

          if (link.arrow) {
            xt = xt - 10;
          }
        }
      }
    }

    return [xs, ys, xt, yt];
  }; // DRAW LINK   


  var drawCurve = function drawCurve(nodes, links, display_style, tags_catalog, link, error_msg) {
    if (!link_visible(link)) {
      return '';
    }

    var link_value = test_link_value(nodes, link, tags_catalog);
    var source_node = nodes[link.idSource];
    var target_node = nodes[link.idTarget];
    var inputLinksId = target_node.inputLinksId;
    var outputLinksId = source_node.outputLinksId;

    if (outputLinksId === undefined || inputLinksId === undefined) {
      return '';
    }

    var _compute_end_points3 = compute_end_points(source_node, target_node, link, nodes, links, tags_catalog),
        _compute_end_points4 = (0, _slicedToArray2.default)(_compute_end_points3, 4),
        xs = _compute_end_points4[0],
        ys = _compute_end_points4[1],
        xt = _compute_end_points4[2],
        yt = _compute_end_points4[3];

    if (link.orientation === 'hh' || link.orientation === 'vv') {
      add_shift_handles(link, nodes, links, display_style, tags_catalog, xs, ys, xt, yt);
    }

    if (link_value > display_style.filter_label) {
      drawLinkText(link, links, link_value, display_style, xs, ys, xt, yt);
    }

    if (link.orientation === 'vh' && !link.recycling) {
      return SankeyShapes.bezier_link_classic_hv(link.idSource, link.idTarget, [xs, ys], [xt, yt], link.curvature !== undefined ? link.curvature : 0.5, link.curved, error_msg);
    }

    if (link.orientation === 'hv' && !link.recycling) {
      return SankeyShapes.bezier_link_classic_vh(link.idSource, link.idTarget, [xs, ys], [xt, yt], link.curvature !== undefined ? link.curvature : 0.5, link.curved, error_msg);
    }

    if (link.orientation === 'hh' && !link.recycling) {
      return SankeyShapes.bezier_link_classic_vv(link.idSource, link.idTarget, [xs, ys], [xt, yt], link.left_horiz_shift, link.right_horiz_shift, link.curvature !== undefined ? link.curvature : 0.5, false, link.curved, error_msg);
    }

    if (link.orientation === 'vv' && !link.recycling) {
      return SankeyShapes.bezier_link_classic_vv(link.idSource, link.idTarget, [xs, ys], [xt, yt], link.left_horiz_shift, link.right_horiz_shift, link.curvature !== undefined ? link.curvature : 0.5, true, link.curved, error_msg);
    }

    if (link.recycling) {
      return SankeyShapes.bezier_link_classic_recycling(link.idSource, link.idTarget, link_value, [xs, ys], [xt, yt], link.left_horiz_shift, link.right_horiz_shift, link.vert_shift, link.curved, link.orientation === 'vv', error_msg, scale);
    }

    return '';
  }; // Returns the x/y position of link_center / left/right/vert_shift


  var handles_positions = function handles_positions(links, link, xs, ys, xt, yt) {
    // let source_node = nodes.filter(n=> n.idNode === link.idSource)[0]
    // let target_node = nodes.filter(n=> n.idNode === link.idTarget)[0]
    // let [xs,ys,xt,yt] = compute_end_points(source_node,target_node,lid,nodes,links,selected_tags)
    if (link.orientation === 'hh' && link.recycling) {
      // Recycling: 3 handles = left_horiz_shift, right_horiz_shif, vert_shift
      if (!link.left_horiz_shift) {
        link.left_horiz_shift = 0;
      }

      if (!link.right_horiz_shift) {
        link.right_horiz_shift = 0;
      }

      if (!link.vert_shift) {
        link.vert_shift = 0;
      }

      var x_left = xt - default_horiz_shift + link.left_horiz_shift - scale(link.value[value_index]); // x14 

      var x_right = xs + default_horiz_shift + link.right_horiz_shift + scale(link.value[value_index]); // x2 

      var y_vert = Math.max(ys, yt) + scale(2 * link.value[value_index]) + link.vert_shift; // y8 

      var vert = 'translate(' + (x_left + (x_right - x_left) / 2 - default_handle_size / 2) + ', ' + (y_vert - default_handle_size / 2) + ')';
      var left = 'translate(' + (x_left - default_handle_size / 2) + ' ,' + (yt + (y_vert - yt) / 2 - default_handle_size / 2) + ')';
      var right = 'translate(' + (x_right - default_handle_size / 2) + ' ,' + (ys + (y_vert - ys) / 2 - default_handle_size / 2) + ')';
      return [vert, left, right];
    } else if (link.orientation === 'vv' && link.recycling) {
      // Recycling: 3 handles = left_horiz_shift, right_horiz_shif, vert_shift
      if (!link.left_horiz_shift) {
        link.left_horiz_shift = 0;
      }

      if (!link.right_horiz_shift) {
        link.right_horiz_shift = 0;
      }

      if (!link.vert_shift) {
        link.vert_shift = 0;
      }

      var y_left = yt - default_horiz_shift + link.left_horiz_shift - scale(link.value[value_index]); // x14 

      var y_right = ys + default_horiz_shift + link.right_horiz_shift + scale(link.value[value_index]); // x2 

      var x_vert = Math.max(xs, xt) + scale(2 * link.value[value_index]) + link.vert_shift; // y8 

      var _vert = 'translate(' + (x_vert - default_handle_size / 2) + ', ' + (y_left + (y_right - y_left) / 2 - default_handle_size / 2) + ')';

      var _left = 'translate(' + (xt + (x_vert - xt) / 2 - default_handle_size / 2) + ' ,' + (y_left - default_handle_size / 2) + ')';

      var _right = 'translate(' + (xs + (x_vert - xs) / 2 - default_handle_size / 2) + ' ,' + (y_right - default_handle_size / 2) + ')';

      return [_vert, _left, _right];
    } else if (link.orientation === 'hh') {
      if (!link.left_horiz_shift) {
        link.left_horiz_shift = 1 / 3;
      }

      if (!link.right_horiz_shift) {
        link.right_horiz_shift = 2 / 3;
      }

      var shift_left = 'translate(' + (xs + (xt - xs) * link.left_horiz_shift) + ', ' + (ys - default_handle_size / 2) + ')';
      var shift_right = 'translate(' + (xs + (xt - xs) * link.right_horiz_shift) + ', ' + (yt - default_handle_size / 2) + ')';
      return [shift_left, shift_right];
    } else if (link.orientation === 'vv') {
      if (!link.left_horiz_shift) {
        link.left_horiz_shift = 1 / 3;
      }

      if (!link.right_horiz_shift) {
        link.right_horiz_shift = 2 / 3;
      }

      var _shift_left = 'translate(' + (xs - default_handle_size / 2) + ', ' + (ys + (yt - ys) * link.left_horiz_shift) + ')';

      var _shift_right = 'translate(' + (xt - default_handle_size / 2) + ', ' + (ys + (yt - ys) * link.right_horiz_shift) + ')';

      return [_shift_left, _shift_right];
    } else if (link.orientation === 'vh') {
      var x_center_draw = xs;
      var y_center_draw = yt;
      return ['translate(' + x_center_draw + ', ' + y_center_draw + ')'];
    } else if (link.orientation === 'hv') {
      var _x_center_draw = xt;
      var _y_center_draw = ys;
      return ['translate(' + _x_center_draw + ', ' + _y_center_draw + ')'];
    }

    return [''];
  };

  var swap = function swap(array, x, y) {
    var temp = array[x];
    array[x] = array[y];
    array[y] = temp;
  };

  var drag_node_text = function drag_node_text(node, event) {
    var old_x = +d3.select('#' + node.idNode + '_text').attr('x'),
        old_y = +d3.select('#' + node.idNode + '_text').attr('y'),
        new_x = old_x + event.dx,
        new_y = old_y + event.dy;
    d3.select('#' + node.idNode + '_text').attr('x', new_x);
    d3.select('#' + node.idNode + '_text').attr('y', new_y);
    node.x_label = new_x;
    node.y_label = new_y;
    d3.select('#' + node.idNode + '_text').selectAll('tspan').attr('x', new_x);
  };

  var drag_link_text = function drag_link_text(link, event) {
    var old_x = +d3.select('#' + link.idLink + '_text').attr('x'),
        old_y = +d3.select('#' + link.idLink + '_text').attr('y'),
        new_x = old_x + event.dx,
        new_y = old_y + event.dy;
    d3.select('#' + link.idLink + '_text').attr('x', new_x);
    d3.select('#' + link.idLink + '_text').attr('y', new_y);
    link.x_label = new_x;
    link.y_label = new_y;
    link.label_position = 'frozen';
  };

  var add_nodes = function add_nodes(static_sankey) {
    var remove_previous_nodes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var display_style = data.display_style;

    if (remove_previous_nodes) {
      d3.selectAll('.gg_nodes').remove();
    }

    var gg_nodes = d3.select('#g_nodes').selectAll('.gg_nodes').data(Object.values(display_nodes)).enter().append('g').attr('id', function (d) {
      return 'gg_' + d.idNode;
    }).attr('class', 'gg_nodes') // On gere la visibilité directement sur gg_nodes avec un display <inline />
    // Cela permettra de mieux gérer des zooms sur les éléments visibles
    .style('display', function (d) {
      var display;

      if (d.node_visible) {
        display = 'inline';
      } else {
        display = 'none';
      }

      return display;
    });
    var ggg_nodes = gg_nodes.append('g').attr('id', function (d) {
      return 'ggg_' + d.idNode;
    }).attr('class', 'ggg_nodes').attr('transform', function (d) {
      return 'translate(' + d.x + ', ' + d.y + ')';
    });

    if (!static_sankey) {
      // Gestion du drag 
      ggg_nodes.call(d3.drag().subject(Object).on('drag', function (event) {
        drag_node(display_nodes, display_links, display_style, data.tags_catalog, this, event);
        localStorage.setItem('data', JSON.stringify(data));
      })); // Gestion du click  

      ggg_nodes.on('click', function (event, d) {
        /* sankeyTooltip.style('opacity', 0) // Fermeture de la tooltip au click
        select_node(d.id)
        deselect_nodes_and_links()
        const node_to_select = '#ggg_node' + node_idx + ' rect'
        d3.select(node_to_select).attr('class', 'selected_node')
        return */
        if (event.ctrlKey) {
          // set_selected_node(nodes.filter(f => { return f.name == event.target.value })[0].id)
          sankeyTooltip.style('opacity', 0);
          select_node(d);
          set_nav_item_active('2');
          set_show_nav(true);
        }
      });
      ggg_nodes.on('dblclick', function (ev, n) {
        if (!n.dimensions) {
          return;
        }

        if (ev.altKey) {
          var child_names = [];
          var dim_names = [];
          Object.values(data.nodes).forEach(function (n2) {
            for (var dim in n2.dimensions) {
              if (n2.dimensions[dim].parent_name == n.idNode) {
                if (dim_names.indexOf(dim) === -1) {
                  child_names.push(n2.idNode);
                  dim_names.push(dim);
                }
              }
            }

            return false;
          });

          if (child_names.length === 0) {
            return;
          }

          if (child_names.length > 1) {
            set_agregation_parent_names(child_names);
            set_agregation_dimension_names(dim_names);
            set_is_agregation(false);
            set_show_agregation(true);
          } else {
            (0, _SankeyLayout.desagregation)(data, child_names[0], dim_names[0]);
          }
        } else {
          var parent_names = [];
          var _dim_names = [];
          Object.keys(n.dimensions).forEach(function (dim) {
            if (n.dimensions[dim].parent_name) {
              parent_names.push(n.dimensions[dim].parent_name);

              _dim_names.push(dim);
            }
          });

          if (parent_names.length === 0) {
            return;
          }

          if (parent_names.length > 1) {
            set_agregation_parent_names(parent_names);
            set_agregation_dimension_names(_dim_names);
            set_is_agregation(true);
            set_show_agregation(true);
          } else {
            (0, _SankeyLayout.agregation)(data, parent_names[0], _dim_names[0]);
          }
        }

        set_data((0, _objectSpread2.default)({}, data));
      });
    } // Gestion du contextMenu 


    ggg_nodes.on('contextmenu', function (event, node) {
      event.preventDefault();
      sankeyTooltip.style('opacity', 0);
      nodeContextMenu(node);
    }); // Gestion du shape (rect ou cicle)
    // A reprendre

    ggg_nodes.filter(function (d) {
      return d.type === 'sector';
    }).append('rect').classed('node', true).classed('node_shape', true).attr('width', default_node_size).attr('height', default_node_size);
    ggg_nodes.filter(function (d) {
      return d.type === 'product';
    }).append('ellipse').classed('node', true).classed('node_shape', true).attr('stroke-opacity', 0).attr('cx', default_node_size / 2).attr('cy', default_node_size / 2).attr('rx', default_node_size / 2).attr('ry', default_node_size / 2).attr('height', default_node_size).attr('width', default_node_size);
    d3.selectAll('.node').attr('id', function (d) {
      return d.idNode;
    }).attr('visibility', function (d) {
      return d.node_visible && d.shape_visible ? 'visible' : 'hidden';
    }).attr('fill', function (d) {
      return node_color(d);
    }) //.attr('fill-opacity', d => (d as SankeyNode).visible ? 0.9 : 0)
    .attr('stroke', 'black').attr('stroke-width', '0') // Gestion de la tooltip
    .on('mouseover', function (event, d) {
      if (d.shape_visible && (event.shiftKey || static_sankey)) {
        //d3.select(this).attr('class', 'selected_node')
        sankeyTooltip.style('opacity', 1).html(nodeTooltipsContent(data, d, getValueIndex));
      }
    }).on('mousemove', function (event, d) {
      if (d.shape_visible && (event.shiftKey || static_sankey)) {
        sankeyTooltip.style('top', event.layerY - 10 + 'px').style('left', event.layerX + 10 + 'px');
      }
    }).on('mouseout', function (event, d) {
      if (d.shape_visible) {
        //d3.select(this).attr('class', 'node')
        sankeyTooltip.style('opacity', 0);
      }
    }).on('click', function (event, d) {
      if (event.shiftKey) {
        // Animation des flux du Sankey
        sankeyTooltip.style('opacity', 0);
        d3.selectAll('#svg .tmp').remove(); // on donne ici un style temporaire, les parametres initiaux restent dans le attr que l'on pourra récupérer plus tard pour la remise en état du sankey       

        d3.select('#svg').selectAll('.arrow').style('fill', '#dddddd');
        d3.select('#svg').selectAll('.link').style('stroke', '#dddddd');
        d3.select('#svg').selectAll('.node').style('fill', '#dddddd');
        d3.select('#svg').selectAll('.link_value').style('display', 'none');
        var nodeDisplay = [d.idNode];
        branchAnimate(data.nodes, d, nodeDisplay);
      }
    }); // Creation des Arrows 
    // -> deplacer dans le add_link 
    // ggg_nodes
    //   .filter(n => node_arrow_visible(n))
    //   .each(function (n) {
    //     const selection = (d3.select(this) as unknown) as d3.Selection<d3.BaseType, SankeyNode, HTMLElement, SankeyNode>
    //     drawArrows(n, display_nodes, display_links, display_style, data.tags_catalog, selection)
    //   })
    // Gestion des nodes label
    // A reprendre peut-être avec des foreignObjects

    var select = ggg_nodes.append('text').classed('node', true).classed('node_text', true).attr('id', function (n) {
      return n.idNode + '_text';
    }).attr('x', function (n) {
      return n.x_label ? n.x_label : 0;
    }).attr('y', function (n) {
      if (n.y_label) {
        return n.y_label;
      }

      setNodeHeight(n, display_nodes, display_links, data.tags_catalog);
      var height = +d3.select('#' + n.idNode).attr('height');
      return height + 13;
    }).attr('text-anchor', 'center').attr('visibility', function (n) {
      return n.node_visible && n.label_visible ? 'visible' : 'hidden';
    }).style('text-align', 'center').attr('style', function (d) {
      var font = d.type === 'product' ? 'Arial' : 'Calibri';
      var font_style = d.type === 'sector' && display_style.sector_italic || d.type === 'product' && display_style.product_italic ? 'italic' : 'normal';
      var font_weight = d.type === 'sector' && display_style.sector_bold || d.type === 'product' && display_style.product_bold ? 'bold' : 'normal';
      return 'font-family:' + font + ';font-size:' + display_style.font_size + 'px;font-style: ' + font_style + ';font-weight: ' + font_weight + ';';
    }).text(function (d) {
      var total = 0;

      if (d.show_value) {
        if (d.outputLinksId.length > 0) {
          for (var i = 0; i < d.outputLinksId.length; i++) {
            var link = display_links[d.outputLinksId[i]];

            if (link === undefined) {
              //alert('Corruption du diagramme')
              return '';
            }

            if (display_nodes[link.idSource].node_visible && display_nodes[link.idTarget].node_visible) {
              total += +link.value[value_index];
            }
          }
        }

        if (total === 0) {
          if (d.inputLinksId.length > 0) {
            for (var _i4 = 0; _i4 < d.inputLinksId.length; _i4++) {
              var _link = display_links[d.inputLinksId[_i4]];

              if (_link === undefined) {
                //alert('Corruption du diagramme')
                return '';
              }

              if (display_nodes[_link.idSource].node_visible && display_nodes[_link.idTarget].node_visible) {
                total += +_link.value[value_index];
              }
            }
          }
        }
      }

      if (d.type === 'sector' && display_style.sector_uppercase || d.type === 'product' && display_style.product_uppercase) {
        if (d.show_value) {
          return d.name.split(' - ')[0].replace('-', ' ').replace('Transformation', 'Transfo').toUpperCase() + ' : ' + (0, _SankeyUtils.toPrecision)(total) + data.units_names[0];
        } else {
          return d.name.split(' - ')[0].replace('-', ' ').replace('Transformation', 'Transfo').toUpperCase();
        }
      } else {
        if (d.show_value) {
          return d.name.split(' - ')[0].replace('-', ' ').replace('Transformation', 'Transfo') + ' : ' + (0, _SankeyUtils.toPrecision)(total) + data.units_names[0];
        } else {
          return d.name.split(' - ')[0].replace('-', ' ').replace('Transformation', 'Transfo');
        }
      }
    }).each(function (d) {
      var width = 110;

      if (d.name.split(' - ').length === 3) {
        width = 250;
      }

      var wrap = (0, _d3Textwrap.textwrap)().bounds({
        height: 100,
        width: width
      }).method('tspans');
      d3.select('#ggg_' + d.idNode + ' text').call(wrap);
    }).on('mouseover', function (event, d) {
      if (d.label_visible && (static_sankey || event.shiftKey)) {
        //d3.select(this).attr('class', 'selected_node')
        sankeyTooltip.style('opacity', 1).html(nodeTooltipsContent(data, d, getValueIndex));
      }
    }).on('mousemove', function (event, d) {
      if (d.label_visible && (static_sankey || event.shiftKey)) {
        sankeyTooltip.style('top', event.layerY - 10 + 'px').style('left', event.layerX + 10 + 'px');
      }
    }).on('mouseout', function (event, d) {
      if (d.label_visible) {
        //d3.select(this).attr('class', 'node')
        sankeyTooltip.style('opacity', 0);
      }
    });

    if (!static_sankey) {
      select.on('click', function (event, n) {
        select_node(n);
        deselect_nodes_and_links();
        d3.select('#ggg_' + n.idNode + ' rect').attr('class', 'selected_node');
        return;
      }).call(d3.drag().subject(Object).on('drag', function (event, node) {
        if (alt_key_pressed === true) {
          drag_node_text(node, event);
        } else {
          var node_to_drag = 'ggg_node' + d3.select(this).attr('id').substring(4, 6);
          var el = document.getElementById(node_to_drag);

          if (el) {
            drag_node(display_nodes, display_links, display_style, data.tags_catalog, el, event);
          }
        }
      }));
    }
  };

  var branchAnimate = function branchAnimate(nodes, nodeData, nodeDisplay) {
    // Permet la progation de l'animation sur l'ensemble du Sankey
    var nodeStart = nodeData.idNode; //console.log('Click on gg.node ' + nodeStart)
    // on pourrait aussi evnetuellement faire un clone des noeuds

    d3.select('#' + nodeData.idNode).style('fill', d3.select('#' + nodeData.idNode).attr('fill'));
    d3.select('#' + nodeData.idNode + '_text').style('fill', d3.select('#' + nodeData.idNode).attr('fill'));
    var glinks = d3.select('#svg').selectAll('.gg_links').filter(function (d) {
      return d.idSource == nodeStart;
    }); // On fait une copie du link pour son animation, celle-ci sera supprimé après l'animation  (classe .tmp)

    var tmpLinks = glinks.clone(true).raise().attr('class', 'tmp');
    tmpLinks.selectAll('.link').each(function () {
      var totalLength = this.getTotalLength();
      d3.select(this).attr('stroke-dasharray', totalLength + ' ' + totalLength).attr('stroke-dashoffset', totalLength).style('stroke', function (d) {
        // on recupere les paramêtres initiaux du stroke
        return d3.select(this).attr('stroke');
      });
    }).transition().duration(2000).attr('stroke-dashoffset', 0).on('end', function (d) {
      var idLink = d3.select(this).attr('id');
      var idTarget = data.links[idLink].idTarget; // Modification des arrows après l'animation

      var arrowInitColor = d3.select(this.parentNode).select('.arrow').attr('fill');
      d3.select(this.parentNode).select('.arrow').style('fill', arrowInitColor); // reaffichage des link value après l'animation

      d3.select(this.parentNode).select('.link_value').style('display', 'inline'); //Propagration de l'animation sur les flux sortant du target_node
      // on teste si le noeud est déjà passé cela permet de régler le problème des links à 'recycling'

      if (!nodeDisplay.includes(idTarget)) {
        nodeDisplay.push(idTarget);
        branchAnimate(nodes, nodes[idTarget], nodeDisplay);
      }
    });
  };

  var drawArrows = function drawArrows(n, nodes, links, display_style, tags_catalog, selection) {
    var cum_v_left = 0;
    var cum_h_top = 0;
    var cum_v_right = 0;
    var cum_h_bottom = 0;
    var is_v = true; // a quoi ca sert ?

    var tmp = selection.selectAll('path');
    tmp.remove();
    var res = (0, _SankeyUtils.compute_total_offsets)(n, nodes, links, tags_catalog, test_link_value);

    var _res14 = (0, _slicedToArray2.default)(res, 4),
        total_height_left = _res14[0],
        total_height_right = _res14[1],
        total_width_top = _res14[2],
        total_width_bottom = _res14[3];

    var _loop2 = function _loop2(i) {
      var l = links[n.inputLinksId[i]];

      if (!data.nodes[l.idSource].node_visible && data.nodes[l.idTarget].node_visible) {
        return "continue";
      }

      var link_value = test_link_value(nodes, l, tags_catalog);

      if (link_value === undefined) {
        return "continue";
      }

      var source_node = nodes[l.idSource];

      if (l.orientation === 'hh' || l.orientation === 'vh') {
        is_v = true;
      } else {
        is_v = false;
      }

      if (!display_style.filter || link_value >= display_style.filter) {
        //selection
        d3.select('#gg_' + l.idLink + ' .arrow').remove(); // supression dans le cas du drag notamment

        setNodeHeight(n, nodes, links, tags_catalog);
        d3.select('#gg_' + l.idLink).append('path').attr('class', 'arrow').attr('id', l.idLink + '_arrow').attr('d', function () {
          var xt;
          var yt;
          var p5;

          if (l.orientation === 'hh' || l.orientation === 'vh') {
            if (n.x <= source_node.x && l.recycling || n.x > source_node.x && !l.recycling) {
              xt = +n.x;
              yt = +n.y + +d3.select('#' + n.idNode).attr('height') / 2;
              p5 = [xt, yt];
              is_v = true;
              return SankeyShapes.draw_arrow(scale(total_height_left) / 2, p5, scale(link_value), scale(cum_v_left), true, false);
            } else {
              xt = +n.x + +d3.select('#' + n.idNode).attr('width');
              yt = +n.y + +d3.select('#' + n.idNode).attr('height') / 2;
              p5 = [xt, yt];
              is_v = true;
              return SankeyShapes.draw_arrow(scale(total_height_right) / 2, p5, scale(link_value), scale(cum_v_right), true, true);
            }
          } else if (l.orientation === 'vv' || l.orientation === 'hv') {
            if (n.y > source_node.y) {
              xt = +n.x + +d3.select('#' + n.idNode).attr('width') / 2;
              yt = +n.y;
              p5 = [xt, yt];
              is_v = false;
              return SankeyShapes.draw_arrow(scale(total_width_top) / 2, p5, scale(link_value), scale(cum_h_top), false, false);
            } else {
              xt = +n.x + +d3.select('#' + n.idNode).attr('width') / 2;
              yt = +n.y + +d3.select('#' + n.idNode).attr('height');
              p5 = [xt, yt];
              is_v = false;
              return SankeyShapes.draw_arrow(scale(total_width_bottom) / 2, p5, scale(link_value), scale(cum_h_bottom), false, true);
            }
          }

          return '';
        }) // .attr('transform', () => 'translate(' + -(n.x) + ', ' + -(n.y) + ')')
        .attr('fill', function () {
          return link_color(l, value_index);
        }).attr('fill-opacity', function () {
          var opacity = String(!data.show_uncert && l.display_value[value_index]).includes('[') ? 0.85 : 0.85;
          return opacity;
        });
      }

      if (is_v && (n.x > source_node.x && !l.recycling || n.x < source_node.x && l.recycling)) {
        cum_v_left += link_value;
      } else if (is_v && n.x < source_node.x && !l.recycling || n.x > source_node.x && l.recycling) {
        cum_v_right += link_value;
      } else if (!is_v && n.y > source_node.y) {
        cum_h_top += link_value;
      } else if (!is_v && n.y < source_node.y) {
        cum_h_bottom += link_value;
      }
    };

    for (var i = 0; i < n.inputLinksId.length; i++) {
      var _ret = _loop2(i);

      if (_ret === "continue") continue;
    }
  };

  var scale = d3.scaleLinear().domain([0, 100]).range([0, 100]);
  var inv_scale = d3.scaleLinear().domain([0, 100]).range([0, 100]); // ALT KEY INTERACTION: MOVE LABELS

  alt_key_pressed = false;
  window.focus();
  d3.select(window).on('keydown', function (event) {
    if (event.keyCode === 18) {
      alt_key_pressed = true;
      window.focus();
    }
  });
  d3.select(window).on('keyup', function (event) {
    if (event.keyCode === 18) {
      alt_key_pressed = false;
      window.focus();
    }
  });

  var drawLegend = function drawLegend(nodes, tags_catalog) {
    // Dans le menu tags, les éléments affichés dans la légende sont :
    // les tagGroup pour lesquelles Legend est à true 
    // le selected du tags à true
    //console.log('FUNCTION : drawLegend')
    // dx permet de faire en décalage vers la gauche lorsque l'on change de groupTags
    var dx = 0;
    var pas = 180;
    d3.select('#g_legend').selectAll('*').remove();
    var legend = d3.select('#g_legend').style('transform', 'translate(' + data.legend_position[0] + 'px,' + data.legend_position[1] + 'px)').append('g');
    var wrap = (0, _d3Textwrap.textwrap)().bounds({
      height: 100,
      width: pas - 40
    }).method('tspans');
    Object.values(data.tags_catalog).filter(function (tag_group) {
      return tag_group.show_legend;
    }).forEach(function (tag_group) {
      // Ajout du tagGroup.name  
      var legendTitle = legend.append('text').attr('transform', function (d, i) {
        return 'translate(' + dx + ', 0 )';
      }).attr('x', 0).attr('y', 0).text(tag_group.group_name).attr('style', 'font-weight:bold').call(wrap);
      var legendElements = legend.append('g').selectAll('g') // je comprends pas trop avant on utilisait d3.entries il semble etre remplacé par Object.entries(), mais ca ne donne pas la même chose
      .data(Object.entries(tag_group.tags)).enter().append('svg:g') // on filtre les tags avec selected à true (Visible)
      .filter(function (d) {
        return d[1].selected;
      }).attr('transform', function (d, i) {
        return 'translate(' + dx + ',' + i * 30 + ')';
      }); // Ajout du shape  

      legendElements.append('rect').attr('width', 20).attr('height', 20).attr('x', 0).attr('y', 10).attr('rx', 3).attr('ry', 3).style('fill', function (d) {
        return d[1].color;
      }).style('fill-opacity', 1); // Ajout du label

      legendElements.append('text').attr('x', 35).attr('y', 20).text(function (d) {
        return d[1].name;
      }).call(wrap);
      dx = dx + pas;
    }); // On translateY #g_nodes et #g_links de la hauteur de la légende
    //d3.select('#g_nodes').style('transform', 'translateY(50px)')
    //d3.select('#g_links').style('transform', 'translateY(50px)')
  };

  (0, _react.useEffect)(function () {
    d3.selectAll('.tmp').remove();
    var height = 0;
    Object.values(data.nodes).forEach(function (n) {
      return height = n.y && n.node_visible ? Math.max(height, n.y) : height;
    });
    var min_height = 2000;
    Object.values(data.nodes).forEach(function (n) {
      return min_height = n.y && n.node_visible ? Math.min(min_height, n.y) : min_height;
    });
    var max_vert_shift = 0;
    Object.values(data.links).forEach(function (l) {
      return max_vert_shift = l.vert_shift ? Math.max(max_vert_shift, l.vert_shift) : max_vert_shift;
    });
    height = Math.max(500, height + max_vert_shift + 200);
    var svgSankey = d3.select('#svg');
    svgSankey.attr('viewBox', [0, 0, data.width, height]).attr('cursor', 'grab').call(d3.zoom().filter(function filter(event) {
      // Permet d'obliger Crtl pour activer le zoom
      return event.ctrlKey;
    }).wheelDelta(function wheelDelta(event) {
      // Permet de regler la vitesse du zoom
      return -event.deltaY * (event.deltaMode === 1 ? 0.05 : event.deltaMode ? 1 : 0.002);
    }).on('zoom', function (transform) {
      //d3.selectAll('svg > *') // permet de sélectionner l'ensemble des éléments de la balise svg
      d3.select('#g_nodes').attr('transform', transform.transform);
      d3.select('#g_links').attr('transform', transform.transform);
      d3.selectAll('#g_nodes text').style('font-size', function () {
        return data.display_style.font_size / transform.transform.k + 'px'; // Permet de maintenir une taille de police constante
        // A voir si il ne faut pas la réduire quand le zomm est <1
      });
      d3.selectAll('#g_links text').style('font-size', function () {
        return data.display_style.font_size / transform.transform.k + 'px'; // Permet de maintenir une taille de police constante
        // A voir si il ne faut pas la réduire quand le zomm est <1
      });
    }));
    update_scale(data.user_scale);
    add_nodes(data.static_sankey, true);
    add_links(data.static_sankey, true);
    var gg_nodes = d3.select('#g_nodes').selectAll('.gg_nodes');
    gg_nodes.attr('cursor', 'zoom-in');
    var gg_links = d3.select('#g_links').selectAll('.gg_links');
    gg_links.attr('cursor', 'zoom-in');
    drawLegend(data.nodes, data.tags_catalog);
    localStorage.setItem('data', JSON.stringify(data));
    console.log(data);
  });
  var height = 0;
  Object.values(data.nodes).forEach(function (n) {
    return height = n.y && n.node_visible ? Math.max(height, n.y) : height;
  });
  var max_vert_shift = 0;
  Object.values(data.links).forEach(function (l) {
    return max_vert_shift = l.vert_shift ? Math.max(max_vert_shift, l.vert_shift) : max_vert_shift;
  });
  height = Math.max(500, height + max_vert_shift + 200);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "span12",
    style: {
      'color': 'black',
      'backgroundColor': 'WhiteSmoke',
      'marginLeft': '10px'
    },
    id: "visualization_div"
  }, /*#__PURE__*/_react.default.createElement("svg", {
    height: height,
    width: "100%",
    id: "svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    className: "g_legend",
    id: "g_legend"
  }), /*#__PURE__*/_react.default.createElement("g", {
    className: "g_nodes",
    id: "g_nodes"
  }), /*#__PURE__*/_react.default.createElement("g", {
    className: "g_links",
    id: "g_links"
  }))), /*#__PURE__*/_react.default.createElement(_SankeyLayout.AgregationModal, {
    show_agregation: show_agregation,
    data: data,
    set_data: set_data,
    parent_names: agregation_parent_names,
    dimension_names: agregation_dimension_names,
    set_show_agregation: set_show_agregation,
    is_agregation: is_agregation
  }));
};

var _default = SankeyDraw;
exports.default = _default;